import { useState } from "react";
import { Link } from "react-router-dom";
import PageShell, { hasConfirmSlot } from "../components/PageShell";
import copy from "../lib/catalog/copy-strings.json";

export default function FaqPage() {
        const c = copy.faq;
        const [open, setOpen] = useState(0);
        const hasConfirm = hasConfirmSlot(...c.items.map(x => x.a));
        return (
                <PageShell title={c.title} path="/faq" hasConfirm={hasConfirm}>
                        <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#F59E0B]">{c.eyebrow}</p>
                        <h1 className="mt-3 font-display uppercase leading-[0.95] text-[38px] md:text-[48px] lg:text-[64px]">
                                <span className="text-white">{c.heading_lead}</span>
                                <span className="text-[#F59E0B]">{c.heading_accent}</span>
                        </h1>

                        <section className="mt-12 divide-y divide-white/10 border-y border-white/10" data-testid="faq-accordion">
                                {c.items.map((item, i) => {
                                        const expanded = open === i;
                                        return (
                                                <div key={i} data-testid={`faq-item-${i}`}>
                                                        <button
                                                                type="button"
                                                                onClick={() => setOpen(expanded ? -1 : i)}
                                                                aria-expanded={expanded}
                                                                className="w-full min-h-[48px] flex items-center justify-between text-left py-4 px-2 hover:bg-white/5"
                                                        >
                                                                <span className="text-white font-mono text-[13px] tracking-[0.04em]">{item.q}</span>
                                                                <span className="text-[#F59E0B] font-mono">{expanded ? "−" : "+"}</span>
                                                        </button>
                                                        <div hidden={!expanded} className="pb-5 px-2 text-white/70 leading-relaxed text-sm max-w-[68ch]">{item.a}</div>
                                                </div>
                                        );
                                })}
                        </section>

                        <p className="mt-10 text-white/70">
                                Couldn't find your answer? <Link to="/contact" className="text-[#F59E0B]">Talk to a human ➔</Link>
                        </p>
                </PageShell>
        );
}
